import React from 'react'
import { Button } from '@mui/material'
import GoogleIcon from '../../../icon/GoogleIcon'
import { EXPORT_BUTTON_ICON_COLOR } from '../style/metricsIndexStyles'

const ExportButton = ({
  label = 'Descargar',
  disabled = false,
  className = '',
  startIcon,
  standalone = false,
  children,
  ...props
}) => (
  <Button
    className={[
      'download-doble-reports',
      standalone ? 'download-doble-reports-single' : '',
      className
    ]
      .filter(Boolean)
      .join(' ')}
    disabled={disabled}
    startIcon={startIcon ?? <GoogleIcon name="download_2" size={16} filled color={EXPORT_BUTTON_ICON_COLOR} />}
    {...props}
  >
    {children ?? label}
  </Button>
)

export default ExportButton
